import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap, zip} from 'rxjs';
import { ShipmentDocument, ShipmentMasterModel } from '../models/auditing-workflow/shipment-master.model';
import { environment } from '../../../environments/environment';
import { LoadMasterModel } from '../models/auditing-workflow/load-master.model';
import { ApiService } from './api.service';
import { CustomerReviewStatusModel } from '../models/master-list/customer-review-status.model';
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ShipmentMasterService {
  readonly loadMaster$: BehaviorSubject<LoadMasterModel | null>;
  readonly shipmentMaster$: BehaviorSubject<ShipmentMasterModel | null>;

  constructor(private readonly apiService: ApiService) {
    this.loadMaster$ = new BehaviorSubject<LoadMasterModel | null>(null);
    this.shipmentMaster$ = new BehaviorSubject<ShipmentMasterModel | null>(null);
  }

  getShipmentAndLoad(shipmentID: number, loadID: number): void {
    zip(this.getShipmentMaster(shipmentID), this.getLoadMaster(loadID))
      .pipe(
        tap(result => {
          this.shipmentMaster$.next(result[0]);
          this.loadMaster$.next(result[1]);
        })
      ).subscribe();
  }

  getShipmentMaster(shipmentID: number): Observable<ShipmentMasterModel> {
    return this.apiService.get<ShipmentMasterModel>(environment.hairballAuditingWorkflow.shipmentMaster + shipmentID);
  }

  getLoadMaster(loadID: number): Observable<LoadMasterModel | null> {
    return this.apiService.get<LoadMasterModel | null>(environment.hairballAuditingWorkflow.loadMaster + loadID);
  }

  getLoadMasterByLoad(MBL: any): Observable<LoadMasterModel[]> {
    return this.apiService.post<LoadMasterModel[]>(environment.hairballAuditingWorkflow.loadMaster, MBL);
  }

  getAllShipmenMaster(): Observable<ShipmentMasterModel[]> {
    return this.apiService.get<ShipmentMasterModel[]>(environment.hairballAuditingWorkflow.shipmentMaster);
  }

  manageShipmentDocument(action: string, shipmentDocument?: ShipmentDocument): Observable<any> {
    if (action === 'add') {
      return this.apiService.post<any>(environment.hairballAuditingWorkflow.shipmentDocument, shipmentDocument);
    } else {
      return this.apiService.delete<any>(environment.hairballAuditingWorkflow.shipmentDocument + shipmentDocument.ShipmentDocID);
    }
  }

  getCustomerReviewStatuses() : Observable<CustomerReviewStatusModel[]> {
    return this.apiService.get<CustomerReviewStatusModel[]>(environment.masterList.customerReviewStatuses)
      .pipe(map((response: any) => response.data));
  }

  reapplyExpenseCodes(data: any): Observable<any> {
    return this.apiService.put<any>(environment.hairball.assignExpenseCodeToLoads, data);
  }

  changeCoding(data: any): Observable<any> {
    return this.apiService.put<any>(environment.hairball.changeCoding, data);
  }

  removeLoad(loadId: number, userName: string): Observable<any> {
    return this.apiService.delete<any>(`${environment.hairballAuditingWorkflow.deleteLoad}${loadId}/${userName}`);
  }

  removeShipment(shipmentId: number, userName: string): Observable<any> {
    return this.apiService.delete<any>(`${environment.hairballAuditingWorkflow.deleteShipment}${shipmentId}/${userName}`);
  }

  getShipmentQualificationForASN(custId: string, shipmentId: number): Observable<boolean> {
    return this.apiService.get<any>(`${environment.hairballAuditingWorkflow.getShipmentQualificationForASN}${custId}/${shipmentId}/1`)
      .pipe(map((response: any) => response.data));
  }
  
  sendASN(id: number) {
    return this.apiService.post<any>(environment.operations.sendASN, { "ShipmentId" : id });
  }

  viewASNPdf(shipmentId: number): Observable<Blob> {
    const endpoint = `${environment.operations.viewASNPdf}/${shipmentId}/pdf`;
    return this.apiService.downloadFilePdfGET(endpoint);
  }

}
